import React from "react";

import {
  InlineRadioButton,
  SearchTextBox,
} from "@graffer-inc/console-design-kit";
import {
  ConditionType,
  useSearchBoxController,
} from "./use-search-box-controller";
import "./search-box.scss";
import { emptyFunction } from "../../../../utils/function-utils";

export type SearchBoxProps = {
  query: string;
  condition: ConditionType;
  onChangeSearchText: (searchText: string) => void;
  onChangeSearchCondition: (searchCondition: ConditionType) => void;
};

export const SearchBox: React.FC<SearchBoxProps> = (props) => {
  const { handleOnSearchTextChange, handleOnSearchConditionChange } =
    useSearchBoxController(props);

  const { query, condition } = props;

  return (
    <div className="search-box-container">
      <SearchTextBox
        id="help-search-text-box"
        placeholder=""
        value={query}
        onChange={handleOnSearchTextChange}
        onSearch={emptyFunction}
        errorMessages={undefined}
        shouldDisplayError={false}
        buttonType="None"
      />
      <InlineRadioButton
        label="検索条件"
        onChange={handleOnSearchConditionChange}
        options={[
          {
            name: "AND",
            value: "and",
          },
          {
            name: "OR",
            value: "or",
          },
        ]}
        value={condition}
      />
    </div>
  );
};
